(() => {
  const imageSections = document.querySelectorAll('.about-us-1__images');
  if (!imageSections.length) return;

  imageSections.forEach((query) => {
    const swapTime = query.getAttribute('data-swap-time');
    const images = query.querySelectorAll('.about-us-1__images__image');

    if (!images.length || !swapTime) return;

    // Convert swap time to milliseconds
    const swapInterval = parseInt(swapTime, 10) * 1000;
    let currentIndex = 0;

    // Set initial active image
    images[0].classList.add('active');

    // Function to swap to next image
    const swapToNextImage = () => {
      // Remove active class from current image
      images[currentIndex].classList.remove('active');

      // Move to next image (loop back to 0 if at end)
      currentIndex = (currentIndex + 1) % images.length;

      // Add active class to new image
      images[currentIndex].classList.add('active');
    };

    // Start the swapping interval (use let so we can update it when restarting)
    let swapIntervalId = setInterval(swapToNextImage, swapInterval);

    // Optional: Pause swapping on hover
    query.addEventListener('mouseenter', () => {
      clearInterval(swapIntervalId);
    });

    query.addEventListener('mouseleave', () => {
      swapIntervalId = setInterval(swapToNextImage, swapInterval);
    });
  });
})();
